import { StatsigClient } from '@statsig/react-bindings';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';

const SDK_KEY =
  import.meta.env.VITE_STATSIG_API_KEY ?? import.meta.env.VITE_STATSIG_CLIENT_KEY ?? '';

let client: StatsigClient | null = null;

function toStatsigUser(user: Record<string, any> | null) {
  return user
    ? {
        userID: String(user.id ?? ''),
        email: user.email ?? undefined,
        custom: {
          name: user.name ?? undefined,
          role: user.role ?? undefined
        }
      }
    : {};
}

// Returns the singleton client, creating (and synchronously initializing) it on
// first call only. Safe to call during render — it never triggers updates on an
// already-mounted StatsigProvider.
export default function statsigClientInstance(user: Record<string, any> | null): StatsigClient {
  if (!client) {
    client = new StatsigClient(SDK_KEY, toStatsigUser(user), {
      plugins: [new StatsigSessionReplayPlugin()]
    });
    client.initializeSync();
  }

  return client;
}

// Updates the user on the existing client. This triggers StatsigProvider's
// internal state update, so it must be called from an effect, never during render.
export function updateStatsigUser(user: Record<string, any> | null): void {
  if (!client) return;
  client.updateUserSync(toStatsigUser(user));
}
